import React from 'react';
import ReviewCard from '../review-card';

const Reviews = ({ items, seoTest, useEffect, useState, useRef }) => {
    if (items === null || typeof items === 'undefined') {
        return null;
    }

    return (
        <div className={seoTest ? 'reviews-container' : 'd-flex flex-wrap flex-column flex-md-row justify-content-between'}>
            {items.map((review, i) => (
                <ReviewCard key={i} {...{ review, seoTest, useEffect, useState, useRef }} />
            ))}
        </div>
    );
};

export default Reviews;
